import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { Autocomplete, MenuItem, Typography } from '@emburse/embark-core';
import { getAccountsByName, getAccountById } from '../../api/salesforce';
function SalesforceSearch({ searchBy, onSelect = () => { }, ...props }) {
    const lastKeyword = useRef(undefined);
    const lastValues = useRef([]);
    const defaultValues = useRef([]);
    const gotDefaultValues = useRef(false);
    // Async fetch function for Autocomplete
    const asyncFetch = useCallback(async (keyword) => {
        if (!keyword || keyword.length < 3) {
            return [];
        }
        if (!gotDefaultValues.current) {
            if (searchBy === 'id') {
                // No sensible default for id search
                defaultValues.current = [];
            }
            else {
                try {
                    const response = await getAccountsByName('');
                    defaultValues.current = response.accounts || [];
                }
                catch {
                    defaultValues.current = [];
                }
            }
            gotDefaultValues.current = true;
        }
        if (keyword === lastKeyword.current) {
            return lastValues.current;
        }
        let results = [];
        if (searchBy === 'id') {
            try {
                const response = await getAccountById(keyword);
                results = response.account ? [response.account] : [];
            }
            catch {
                results = [];
            }
        }
        else {
            try {
                const response = await getAccountsByName(keyword);
                results = response.accounts || [];
            }
            catch {
                results = [];
            }
        }
        lastKeyword.current = keyword;
        lastValues.current = results;
        return results;
    }, [searchBy]);
    const getOptionLabel = (option) => option.Id || '';
    const renderOption = (_props, option) => (_jsxs(MenuItem, { ..._props, style: { display: 'block' }, children: [_jsx(Typography, { children: _jsx("strong", { children: option.Name || option.name }) }), _jsx(Typography, { variant: "body2", children: option.Id || option.id })] }));
    const handleChange = (_, value, reason) => {
        onSelect(value, value, reason);
    };
    return (_jsx(Autocomplete, { ...props, isAsync: true, asyncFetch: asyncFetch, asyncOnChangeTimeout: 500, getOptionLabel: getOptionLabel, renderOption: renderOption, onChange: handleChange }));
}
export default SalesforceSearch;
